import { createSlice } from '@reduxjs/toolkit';
import { getRecommendedAds, getSubCategories, getSections, getHomeBanners, getModels } from '../thunks/globalDataThunks';

const globalDataSlice = createSlice({
  name: 'globalData',
  initialState: {
    recommendedAds: [],
    subCategories: [],
    models: [],
    sections: [],
    homeBanners: [],
    lastFetched: null,
  },
  reducers: {
    resetGlobalData: (state) => {
      state.recommendedAds = [];
      state.subCategories = [];
      state.models = [];
      state.sections = [];
      state.homeBanners = [];
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRecommendedAds.fulfilled, (state, action) => {
        state.recommendedAds = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(getSubCategories.fulfilled, (state, action) => {
        state.subCategories = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(getSections.fulfilled, (state, action) => {
        state.sections = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(getHomeBanners.fulfilled, (state, action) => {
        state.homeBanners = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(getModels.fulfilled, (state, action) => {
        state.models = action.payload;
        state.lastFetched = Date.now();
      });
  },
});

export default globalDataSlice.reducer;

export const { resetGlobalData } = globalDataSlice.actions;

